import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M16 0v32c-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M16 32V0c3.75.033 7.567.432 9.69 1.263 4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23M7 9.667a2.667 2.667 0 1 0 0-5.334 2.667 2.667 0 0 0 0 5.334",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M5.667 2h2.667c.184 0 .333.15.333.333v9.334c0 .184-.15.333-.333.333H5.667a.333.333 0 0 1-.333-.333V2.333c0-.184.149-.333.333-.333",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M2.333 5.333h9.334c.184 0 .333.15.333.334v2.666c0 .184-.15.334-.333.334H2.333A.333.333 0 0 1 2 8.333V5.667c0-.184.15-.334.333-.334",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement("path", { fill: "#D9D9D9", d: "M6 2.667h2v8.667H6z" }),
  /* @__PURE__ */ React.createElement("path", { fill: "#D9D9D9", d: "M2.667 6h8.667v2H2.667z" }),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#D9D9D9",
      fillRule: "evenodd",
      d: "M7 9a2 2 0 1 0 0-4 2 2 0 0 0 0 4",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagMlt = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagMlt_default = SvgFlagMlt;

export { FlagMlt_default as default };
